import { getAboutUs } from '@/api/home'

function unwrapAbout (res) {
  if (!res || res.code != 1) return {}
  const d = res.data
  if (!d || typeof d !== 'object') return {}
  if (d.data && typeof d.data === 'object' && !Array.isArray(d.data)) return d.data
  return d
}

const state = {
  appName: '',
  appLogo: '',
  webSiteCopyright: '',
  appSiteIcp: '',
  appSiteIcpHost: '',
  loaded: false
}

const mutations = {
  SET_SITE (state, payload) {
    state.appName = payload.appName || ''
    state.appLogo = payload.appLogo || ''
    state.webSiteCopyright = payload.webSiteCopyright || ''
    state.appSiteIcp = payload.appSiteIcp || ''
    state.appSiteIcpHost = payload.appSiteIcpHost || ''
    state.loaded = true
  }
}

const actions = {
  async fetchSiteInfo ({ commit, state }) {
    if (state.loaded) return
    try {
      const res = await getAboutUs({})
      const d = unwrapAbout(res)
      commit('SET_SITE', {
        appName: d.app_name != null ? String(d.app_name) : '',
        appLogo: d.app_logo != null ? String(d.app_logo) : '',
        webSiteCopyright: d.web_site_copyright != null ? String(d.web_site_copyright) : '',
        appSiteIcp: d.app_site_icp != null ? String(d.app_site_icp) : '',
        appSiteIcpHost: d.app_site_icp_host != null ? String(d.app_site_icp_host) : ''
      })
    } catch (e) {
      commit('SET_SITE', {
        appName: '',
        appLogo: '',
        webSiteCopyright: '',
        appSiteIcp: '',
        appSiteIcpHost: ''
      })
    }
  }
}

const getters = {
  appName: (s) => s.appName,
  appLogo: (s) => s.appLogo,
  webSiteCopyright: (s) => s.webSiteCopyright,
  appSiteIcp: (s) => s.appSiteIcp,
  appSiteIcpHost: (s) => s.appSiteIcpHost,
  siteLoaded: (s) => s.loaded
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
